import { UpgradeType } from '@freelancer/ui/upgrade-tag';
import { ProjectBidStats } from '../projects/projects.model';
import {
  generateProjectObject,
  GenerateProjectOptions,
} from '../projects/projects.seed';
import { Skill } from '../skills/skills.model';
import { phpSkill, pythonSkill } from '../skills/skills.seed';
import { SearchActiveProject } from './search-active-projects.model';
import { transformBidTimeLeft } from './search-active-projects.transformers';

export type GenerateSearchActiveProjectsOptions = GenerateProjectOptions & {
  readonly upgradeTypes?: readonly UpgradeType[];
  readonly skills?: readonly Skill[];
  readonly bidCount?: number;
  readonly bidStats?: ProjectBidStats;
  readonly bidPeriod?: number;
  readonly timeSubmitted?: number;
  readonly description?: string;
};

export function generateSearchActiveProjectsObject(
  options: GenerateSearchActiveProjectsOptions,
): SearchActiveProject {
  return {
    ...generateProjectObject(options),
    ...generateSearchActiveProjectDetails(options),
  };
}

function generateSearchActiveProjectDetails({
  bidCount = 0,
  bidPeriod = 7,
  timeSubmitted = Date.now(),
  budget,
  skills = [phpSkill(), pythonSkill()],
  upgradeTypes = [],
  description = 'I need a new website for my coffee shop This is a project description with more than 30 characters for opening for bidding.',
}: GenerateSearchActiveProjectsOptions) {
  return {
    bidCount,
    bidTimeLeft: transformBidTimeLeft(bidPeriod, timeSubmitted),
    country: undefined,
    description,

    // Flatten the budget object.
    maximumBudget: budget?.maximum ?? Number.MAX_SAFE_INTEGER,
    minimumBudget: budget?.minimum ?? 0,

    searchCoordinates: undefined,
    skills,
    skillIds: skills.map(job => job.id),
    upgradeNames: upgradeTypes,
  };
}
